module.exports = __webpack_public_path__ + "media/images/bg-170d69d1cec20385fb0f88b5fc01aa7a.webp";